<template>
  <div class="floating-actions">
    <!-- 外接客服系统按钮（一直显示，点击直接打开外部域名） -->
    <a 
      :href="customerServiceUrl" 
      class="action-btn customer-service-btn" 
      aria-label="在线客服"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
      </svg>
    </a>

    <!-- 返回顶部按钮（滚动后显示） -->
    <transition name="fade-scale">
      <button
        v-show="isVisible"
        class="action-btn scroll-to-top"
        @click="scrollToTop"
        aria-label="返回顶部"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="18 15 12 9 6 15"></polyline>
        </svg>
      </button>
    </transition>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

// 替换为您实际的客服系统域名链接
const customerServiceUrl = 'https://log.ztctjr.com/chat/index?channelId=cc7238b3e88744828339a302b2b34c3e'

const isVisible = ref(false)

const handleScroll = () => {
  isVisible.value = window.scrollY > window.innerHeight * 0.5
}

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
.floating-actions {
  position: fixed;
  bottom: 20%;
  right: 1.88rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  z-index: 999;
}

.action-btn {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #ffffff;
  border: none;
  text-decoration: none;
  outline: none;
}

/* 客服按钮样式 */
.customer-service-btn {
  background: #c9a96e;
  box-shadow: 0 0.25rem 1rem rgba(201, 169, 110, 0.4);
}

.customer-service-btn:hover {
  transform: translateY(-0.25rem);
  background: #d4b87c;
  box-shadow: 0 0.38rem 1.5rem rgba(201, 169, 110, 0.6);
}

/* 返回顶部按钮样式 */
.scroll-to-top {
  background: #4779B5;
  box-shadow: 0 0.25rem 1rem rgba(71, 121, 181, 0.3);
}

.scroll-to-top:hover {
  transform: translateY(-0.25rem);
  box-shadow: 0 0.38rem 1.88rem rgba(71, 121, 181, 0.6);
}

.action-btn:active {
  transform: translateY(-0.13rem);
}

.fade-scale-enter-active,
.fade-scale-leave-active {
  transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.fade-scale-enter-from,
.fade-scale-leave-to {
  opacity: 0;
  transform: scale(0.5) translateY(1.25rem);
}

@media (max-width: 48rem) {
  .floating-actions {
    bottom: 2.5rem;
    right: 1.25rem;
    gap: 0.625rem;
  }

  .action-btn {
    width: 2.75rem;
    height: 2.75rem;
  }
}
</style>